module.exports = __webpack_public_path__ + "static/img/1.92.207.38.6ee3e2ef.png";